<script lang="ts" setup>
import { ElForm } from "element-plus";
import { ref } from "vue";
import type {
  FormItemProp,
  FormValidateCallback,
  FormValidationResult,
} from "element-plus";
import { excludeObjectKeys } from "../../../utils";
import { ArrayAble, FormProps } from "./form";
import IFormItem from "./form-item.vue";

defineOptions({
  name: "IForm",
});

const props = defineProps(FormProps);
const emit = defineEmits<{
  (e: "validate", prop: FormItemProp, isValid: boolean, message?: string): void;
  (e: "change", key: string, value: any, ref: any, component: string): void;
}>();
const formRef = ref();

defineExpose({
  getRef() {
    return formRef.value;
  },
  validate(callback?: FormValidateCallback): Promise<void> {
    return formRef.value?.validate(callback);
  },
  validateField(
    props?: ArrayAble<FormItemProp>,
    callback?: FormValidateCallback,
  ): FormValidationResult | undefined {
    return formRef.value?.validateField(props, callback);
  },
  resetFields(props?: ArrayAble<FormItemProp>): void {
    formRef.value?.resetFields(props);
  },
  scrollToField(prop: FormItemProp): void {
    formRef.value?.scrollToField(prop);
  },
  clearValidate(props?: ArrayAble<FormItemProp>): void {
    formRef.value?.clearValidate(props);
  },
});
/**
 * 任一表单项值变化后触发
 * @param key
 * @param value
 * @param ref
 * @param component
 */
const handleItemChange = (
  key: string,
  value: any,
  ref: any,
  component: string,
) => {
  emit("change", key, value, ref, component);
  console.log("🚀 ~ key, value, ref, component:", key, value, ref, component);
};

const handleValidate = (
  prop: FormItemProp,
  isValid: boolean,
  message?: string,
) => {
  emit("validate", prop, isValid, message);
};
</script>

<template>
  <ElForm
    ref="formRef"
    class="i-form"
    :model="model"
    v-bind="excludeObjectKeys(props, ['fields', 'column', 'model', 'action'])"
    :style="
      props.column
        ? { gridTemplateColumns: `repeat(${props.column}, 1fr)` }
        : {}
    "
    @validate="handleValidate"
  >
    <IFormItem
      v-for="field of fields"
      v-bind="field"
      :key="field.prop"
      v-model="model[field.prop || '_field']"
      :action="action"
      @change="handleItemChange"
    >
      <template v-for="(item, key) in $slots" :key="key" #[key]>
        <slot :name="key" v-bind="item" />
      </template>
    </IFormItem>
  </ElForm>
</template>
